import {connect} from "react-redux"
import {createSelector} from "reselect"
import State from "../../../models/State"
import {SORT, SORT_BY} from "../../../config/constants"
import filterThroughFacets from "../../../utils/filterThroughFacets"

const selectFilters = (state: State) => state.tabbedFilters.filters
const selectSelectedFilter = (state: State) => state.tabbedFilters.selectedFilter
const selectFreeTextFiltersList = (state: State) => state.search.freeTextFiltersList
const selectFreeTextFilterSearch = (state: State, filterName: string) => state.search.freeTextFilterSearch[filterName]
const selectFacets = (state: State) => state.tabbedFilters.facets
export const selectFilter = createSelector(
    [selectFilters, selectSelectedFilter, selectFacets, selectFreeTextFiltersList, selectFreeTextFilterSearch],
    (filters, selectedFilter, facets, freeTextFiltersList, freeTextFilterSearch) => {
        let filteredFacets = selectedFilter
            ? Object.keys(facets)
                  .filter(facet => facet.startsWith(`${selectedFilter}:`))
                  .map(facetName => facetName)
            : []
        if (selectedFilter && freeTextFiltersList.includes(selectedFilter) && freeTextFilterSearch) {
            const filteredFacetsObject = filterThroughFacets(freeTextFilterSearch, filteredFacets, selectedFilter)
            filteredFacets = [
                ...filteredFacetsObject.filteredFacetsOfTopFive,
                ...filteredFacetsObject.restOfFilteredFacets,
            ]
        }

        let filter = selectedFilter ? {...filters[selectedFilter], facets: filteredFacets} : null
        if (selectedFilter === SORT) {
            filter = {
                name: SORT,
                facets: [],
                isFilterOpen: true,
                displayName: SORT_BY,
                type: "filter",
                isViewMoreOpen: false,
            }
        }
        return filter
    },
)

const mapStateToProps = (state: State) => {
    const {isPerformingKeyFilterSearch, selectedFilter} = state.tabbedFilters
    const {alphabticallySortedFacetsInHorizontalFilters, compositeFiltersList} = state.search
    const {text} = state

    return {
        filter: selectFilter(state, selectedFilter || ""),
        isFetchingPageItems: isPerformingKeyFilterSearch,
        text,
        sortFiltersAlphabatically: selectedFilter
            ? alphabticallySortedFacetsInHorizontalFilters.includes(selectedFilter)
            : false,
        compositeFilter: selectedFilter ? compositeFiltersList.includes(selectedFilter) : false,
    }
}

export default connect(mapStateToProps)
